<template>
  <d-card class="card-small mb-4 h-100">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <d-row class="align-items-center">
        <d-col cols="12" md="auto">
          <h6 class="m-0">Informações de instalação</h6>
        </d-col>
      </d-row>
    </d-card-header>

     <d-card-body class="d-flex flex-column">
      <no-permission v-if="isCustomer" />
      <template v-else>
        <d-form @submit="save" class="d-flex flex-fill flex-column" v-if="model.installation_info">
          <d-form-row>
            <!-- Access type -->
            <d-col cols="12" md="4" class="form-group">
              <label for="name">Tipo de acesso</label>
              <d-select v-model="model.installation_info.access_type" :state="hasErrorFiled('access_type')">
                <option value="Reta">Reta</option>
                <option value="Aclive">Aclive</option>
                <option value="Declive">Declive</option>
              </d-select>
              <d-form-invalid-feedback>Tipo de acesso é obrigatório</d-form-invalid-feedback>
            </d-col>
            <!-- Car Type -->
            <d-col cols="12" md="4" class="form-group">
              <label for="name">Tipo de veículo</label>
              <d-select v-model="model.installation_info.car_type" :state="hasErrorFiled('car_type')">
                <option value="Carreta">Carreta</option>
                <option value="Truck">Truck</option>
                <option value="Carreta e Truck">Carreta e Truck</option>
                <option value="Carreta ou Truck">Carreta ou Truck</option>
              </d-select>
              <d-form-invalid-feedback>Tipo de acesso é obrigatório</d-form-invalid-feedback>
            </d-col>
            <!-- Road Type -->
            <d-col cols="12" md="4" class="form-group">
              <label for="name">Tipo de estrada</label>
              <d-select v-model="model.installation_info.road_type" :state="hasErrorFiled('road_type')">
                <option value="Terra">Terra</option>
                <option value="Asfalto">Asfalto</option>
                <option value="Calçamento">Calçamento</option>
              </d-select>
              <d-form-invalid-feedback>Tipo de acesso é obrigatório</d-form-invalid-feedback>
            </d-col>
          </d-form-row>
          <d-form-row>
            <!-- Installation Time -->
            <d-col cols="12" md="3" class="form-group">
              <label for="name">Horário de instalação</label>
              <d-select v-model="model.installation_info.installation_time" :state="hasErrorFiled('installation_time')">
                <option value="Seg-Sex, 8h-18h">Seg-Sex, 8h-18h</option>
                <option value="Seg-Sex, 9h-18h">Seg-Sex, 9h-18h</option>
                <option value="Seg-Sex">Seg-Sex</option>
              </d-select>
              <d-form-invalid-feedback>Horário de instalação é obrigatório</d-form-invalid-feedback>
            </d-col>
            <!-- Weekend Time -->
            <d-col cols="12" md="3" class="form-group">
              <label for="name">Final de semana</label>
              <d-select v-model="model.installation_info.weekend_time" :state="hasErrorFiled('weekend_time')">
                <option value="Sem restrição de dia e horário">Sem restrição de dia e horário</option>
                <option value="Sábado até as 14h">Sábado até as 14h</option>
                <option value="Sábado e Domingo até as 14h">Sábado e Domingo até as 14h</option>
              </d-select>
              <d-form-invalid-feedback>Final de semana é obrigatório</d-form-invalid-feedback>
            </d-col>
          </d-form-row>
           <d-form-row>
           <!-- Comment -->
            <d-col cols="12" class="form-group ">
              <label for="name">Comentários:</label>
              <textarea
                type="text"
                class="form-control"
                placeholder="Comentário..."
                v-model="model.installation_info.comment"
                rows="5"
              ></textarea>
            </d-col>
          </d-form-row>
        </d-form>
      </template>
      <d-form-row>
        <d-col class="d-flex justify-content-end">
          <button class="btn btn-success" @click="save">Salvar e avançar</button>
        </d-col>
      </d-form-row>

    </d-card-body>

  </d-card>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import Datepicker from '_shared/Datepicker.vue';
import MixinValidateForm from '_common/mixins/ValidateForm';
import QuotationService from '_services/rest/modules/quotation';
import NoPermission from './NoPermission.vue';
import { MODEL, INSTALLATION, _LOAD_MODEL_ } from './QuotationModel';

export default {
  name: 'Step-installation',
  mixins: [MixinValidateForm],
  data() {
    return {
      model: cloneDeep(MODEL),
      errors: {
        car_type: { required: false },
        road_type: { required: false },
        access_type: { required: false },
        weekend_time: { required: false },
        installation_time: { required: false },
      },
    };
  },
  computed: {
    isCustomer() {
      const { user } = this.$store.state.user;
      if (user.settings.user_type_id === 3) {
        return true;
      }
      return false;
    },
  },
  components: {
    Datepicker,
    NoPermission,
  },
  methods: {
    ...mapActions([
      'setToggle',
    ]),
    save() {
      if (this.checkInstallationForm()) {
        this.model.installation_info.quotation_id = this.model.id;
        this.model.step = 'installation_info';
        QuotationService.updateQuotation(this.model)
          .then(response => {
            Events.$emit(_LOAD_MODEL_, response);
            this.$store.commit('setQuotation', response);
            this.$router.push({ name: 'admin-quotation-file', params: { quotationId: response.id } });
          });
      }
    },
    checkInstallationForm() {
      if (this.model.service.service_type === 'Fornecimento') {
        delete this.errors;
        this.errors = {};
      }
      this.submitted = true;
      let valid = true;
      Object.keys(this.model.installation_info).forEach(field => {
        if (this.errors[field]) {
          this.errors[field].required = false;
          if (!this.model.installation_info[field]) {
            this.errors[field].required = true;
            valid = false;
          }
        }
      });
      return valid;
    },
    loadModel(quotation) {
      if (quotation) {
        this.model = quotation;
      }
      if (!this.model.installation_info) {
        this.model.installation_info = cloneDeep(INSTALLATION);
      }
    },
  },
  mounted() {
    const { quotation } = this.$store.state.quotation;
    this.loadModel(quotation);
    Events.$on(_LOAD_MODEL_, model => {
      this.loadModel(model);
    });
  },
};
</script>

<style lang="scss" scoped>

</style>
